import { Component, OnInit, Injectable } from '@angular/core';
import { ChonDoiTuongTHCPService } from './chon-doi-tuong-thcp-service/chon-doi-tuong-thcp.service';
import { BehaviorSubject } from 'rxjs';
import { QueryParamsModel } from 'app/core/_base/crud';

@Component({
    selector: 'kt-chon-doi-tuong-thcp',
    templateUrl: './chon-doi-tuong-thcp.component.html',
    styleUrls: ['./chon-doi-tuong-thcp.component.scss']
})
@Injectable()
export class ChonDoiTuongTHCPComponent implements OnInit {

  constructor(
		private ChonDoiTuongTHCPService : ChonDoiTuongTHCPService
	) {}

  ngOnInit() {
    if (this.ChonDoiTuongTHCPService != undefined)
			this.ChonDoiTuongTHCPService.lastFilter$ = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
  }

}
